/* The contact page's help panel (snippets/contact-help.liquid): its topic tabs, a link that opens one topic
 * (/pages/contact#shipping), the search in the page's hero across every topic at once, and the live-chat card
 * under "Still need us?". Loaded by that snippet only.
 *
 * Every word it shows is already in the page, in the shopper's language: it moves and clones what Liquid
 * rendered, and writes no text of its own.
 */
(function () {
  'use strict';
  var hub = document.querySelector('[data-ch]');
  if (!hub || hub.getAttribute('data-ch-bound')) return;
  hub.setAttribute('data-ch-bound', '1');

  var strip = hub.querySelector('[data-ch-tabs]');
  var tabs = [].slice.call(hub.querySelectorAll('[data-ch-tab]'));
  var panels = [].slice.call(hub.querySelectorAll('[data-ch-panel]'));
  var found = hub.querySelector('[data-ch-found]');
  var noneText = hub.querySelector('[data-ch-none-text]');
  var search = document.querySelector('[data-ch-search][aria-controls="' + hub.id + '"]');
  var KEYS = tabs.map(function (t) { return t.getAttribute('data-ch-tab'); });
  var current = KEYS[0];

  function select(key, focus) {
    current = key;
    tabs.forEach(function (t) {
      var on = t.getAttribute('data-ch-tab') === key;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
      if (on) {
        if (focus) t.focus();
        // On a narrow screen the tabs are one strip that scrolls sideways: bring the chosen one into it.
        // Measured on screen, so it is the same sum reading left to right or right to left.
        if (strip.scrollWidth > strip.clientWidth) {
          var s = strip.getBoundingClientRect(), r = t.getBoundingClientRect();
          strip.scrollLeft += (r.left - s.left) - (s.width - r.width) / 2;
        }
      }
    });
    panels.forEach(function (p) { p.hidden = p.getAttribute('data-ch-panel') !== key; });
  }

  // A topic the shopper picks is kept in the address, so the link they copy opens it.
  function choose(key, focus) {
    if (search && search.value) { search.value = ''; find(''); }
    select(key, focus);
    try { history.replaceState(null, '', '#' + key); } catch (e) {}
  }
  tabs.forEach(function (t) {
    t.addEventListener('click', function () { choose(t.getAttribute('data-ch-tab')); });
  });

  // The tabs pattern: arrows move between topics (the other way round in Arabic and Hebrew), Home and End jump.
  strip.addEventListener('keydown', function (e) {
    var i = KEYS.indexOf(document.activeElement && document.activeElement.getAttribute('data-ch-tab'));
    if (i < 0) return;
    var back = getComputedStyle(strip).direction === 'rtl' ? 'ArrowRight' : 'ArrowLeft';
    var n = null;
    if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') n = e.key === back ? i - 1 : i + 1;
    else if (e.key === 'Home') n = 0;
    else if (e.key === 'End') n = KEYS.length - 1;
    if (n === null) return;
    e.preventDefault();
    choose(KEYS[(n + KEYS.length) % KEYS.length], true);
  });

  function fromHash() {
    var key = (location.hash || '').replace(/^#/, '');
    if (KEYS.indexOf(key) > -1) select(key);
  }
  fromHash();
  window.addEventListener('hashchange', fromHash);

  /* ---- search: every row and every answer, all topics at once ---- */

  // Lower case, accents off ("Rückgabe" finds "ruckgabe"), one space. The same on both sides, so Korean and
  // Japanese, which this splits differently, still compare like with like.
  function norm(s) {
    s = String(s || '').toLocaleLowerCase();
    try { s = s.normalize('NFD').replace(/[\u0300-\u036f]/g, ''); } catch (e) {}
    return s.replace(/\s+/g, ' ').trim();
  }

  // Each row and answer once: "Change the address" sits under two topics and is one result.
  var items = [];
  panels.forEach(function (p) {
    [].forEach.call(p.querySelectorAll('[data-ch-item]'), function (el) {
      var kind = el.getAttribute('data-ch-item'), text = norm(el.textContent);
      for (var i = 0; i < items.length; i++) if (items[i].kind === kind && items[i].text === text) return;
      items.push({ el: el, kind: kind, text: text });
    });
  });

  // Every word typed must appear; "cards" also finds "card".
  function hits(text, words) {
    for (var i = 0; i < words.length; i++) {
      var w = words[i];
      if (text.indexOf(w) > -1) continue;
      if (w.length > 3 && w.charAt(w.length - 1) === 's' && text.indexOf(w.slice(0, -1)) > -1) continue;
      return false;
    }
    return true;
  }

  function find(q) {
    var words = norm(q).split(' ').filter(Boolean);
    if (!words.length) {
      strip.hidden = false; found.hidden = true; noneText.hidden = true;
      select(current);
      return;
    }
    strip.hidden = true;
    panels.forEach(function (p) { p.hidden = true; });
    var any = false;
    ['row', 'qa'].forEach(function (kind) {
      var list = found.querySelector('[data-ch-found-list="' + kind + '"]');
      list.textContent = '';
      items.forEach(function (it) { if (it.kind === kind && hits(it.text, words)) list.appendChild(it.el.cloneNode(true)); });
      found.querySelector('[data-ch-found-col="' + kind + '"]').hidden = !list.firstChild;
      if (list.firstChild) any = true;
    });
    found.hidden = !any;
    noneText.hidden = any;
  }

  if (search) {
    var timer = null;
    search.addEventListener('input', function () {
      clearTimeout(timer);
      timer = setTimeout(function () { find(search.value); }, 120);
    });
    search.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && search.value) { e.preventDefault(); search.value = ''; find(''); }
      if (e.key === 'Enter') {
        e.preventDefault();
        clearTimeout(timer); find(search.value);
        var first = found.hidden ? null : found.querySelector('a[href]');
        if (first) first.focus();
      }
    });
    // A search kept by the browser (back button) is searched again.
    if (search.value) find(search.value);
  }

  /* ---- the live-chat card: opens our chat when it is on this page, otherwise the message box below ---- */
  [].forEach.call(document.querySelectorAll('[data-ch-chat]'), function (btn) {
    btn.addEventListener('click', function () {
      var chat = document.getElementById('mg-chat');
      var fab = chat && chat.querySelector('[data-mg-fab]');
      var panel = chat && chat.querySelector('[data-mg-panel]');
      if (chat && !chat.hidden && fab && !fab.hidden) {
        if (!panel || panel.hidden) fab.click();
        return;
      }
      var box = document.getElementById('contact-message');
      if (box) box.focus();
    });
  });
})();
